module.exports = __webpack_public_path__ + "static/img/Jeremy-McGovern.8017fba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy-McGovern.jpg
// module id = otMR
// module chunks = 0